import { addFilter } from "@wordpress/hooks";

const BACKGROUND_ATTRIBUTE_KEYS = [
	"background",
	"hoverBackground",
	"background1",
	"background2",
	"hoverBackground1",
	"hoverBackground2",
];

const updateBlockAttributes = () => {
	addFilter(
		"blocks.getBlockAttributes",
		"magazine-blocks/update-background-attribute",
		(attrs, block) => {
			if (block.name.startsWith("mzb/")) {
				for (const key of BACKGROUND_ATTRIBUTE_KEYS) {
					if (attrs?.[key]?.image?.image?.type) {
						attrs[key].image.image.url =
							(attrs[key].image.image?.local ?? "") ||
							(attrs[key].image.image?.external ?? "");
						delete attrs[key].image.image.type;
						delete attrs[key].image.image?.local;
						delete attrs[key].image.image?.external;
					}
				}
			}
			return attrs;
		}
	);
};

export default updateBlockAttributes;
